module.exports = __webpack_public_path__ + "img/app-store.a931d372.png";